import {useGenericQuery} from '../../../core/api/reactQuery';
import {getLessonDetails} from "../queries/lesson";
import {useLessonContentStore} from "../stores/lessonContentStore";

export function useContentLesson(slug: string) {
    const {setLesson} = useLessonContentStore()

    const {
        data,
        isError,
        error,
        isSuccess,
        isPending
    } = useGenericQuery(['lesson', slug], () => getLessonDetails(slug), setLesson);

    return {
        data,
        isError,
        isLoading: isPending,
        error,
        isSuccess,
    }
}
